import type { ReactNode } from 'react';
import { T } from 'gt-react';
import type {
  WorkbookDefinition,
  WorkbookDiagnostic,
  WorkbookSheet,
} from '@erp/shared-types';
import { Input } from '@/components/ui/input';
import { PreviewStatus, type SheetPreview } from './SheetEditor';
import { WorksheetDiagnostics } from './WorksheetDiagnostics';

/** A pivot's or freeform sheet's tab heading: its name, preview status and Run menu, then its Diagnostics. */
export function SheetPanelHeading({
  sheet,
  definition,
  diagnostics,
  preview,
  runMenu,
}: {
  sheet: WorkbookSheet;
  definition: WorkbookDefinition;
  diagnostics: readonly WorkbookDiagnostic[];
  preview?: SheetPreview;
  runMenu?: ReactNode;
}) {
  return (
    <>
      <div className="flex items-center gap-2">
        <h2 className="mr-auto truncate text-sm font-medium">{sheet.name}</h2>
        <PreviewStatus preview={preview} definition={definition} />
        {runMenu}
      </div>
      <WorksheetDiagnostics
        sheet={sheet}
        definition={definition}
        diagnostics={diagnostics}
        selectColumn={() => {}}
      />
    </>
  );
}

/** A Worksheet's Name field in its side panel; each keystroke renames it. */
export function SheetNameField({
  name,
  readOnly,
  rename,
  className,
}: {
  name: string;
  readOnly: boolean;
  rename: (name: string) => void;
  className?: string;
}) {
  return (
    <label
      className={`flex flex-col gap-1 text-xs text-muted-foreground ${className ?? ''}`}
    >
      <T context="worksheet name field">Name</T>
      <Input
        className="h-8 text-sm"
        value={name}
        disabled={readOnly}
        onChange={(event) => rename(event.target.value)}
      />
    </label>
  );
}
